import type { AdminTab } from "../types/admin";

export function isAdminTab(value: string): value is AdminTab {
  return (
    value === "content" ||
    value === "users" ||
    value === "history" ||
    value === "clubs" ||
    value === "categoryRequests" ||
    value === "registrations" ||
    value === "payments" ||
    value === "coupons"
  );
}
